import { EndpointContract } from '../../architecture/ControllerContract';
import { z } from 'zod';
import { product } from '../Product';

export const productComparisonRequest = z
    .object({
        productIds: z.array(z.string()).min(1).max(4),
        fillWithSimilarUntil: z.number().min(1).max(4).optional()
    })
    .strict();

export const productComparisonResult = z.object({
    products: z.array(product),
    groups: z.array(
        z.object({
            group: z.string(),
            attributes: z.array(
                z.object({
                    name: z.string(),
                    values: z.array(
                        z.object({
                            productId: z.string(),
                            value: z.string()
                        })
                    )
                })
            )
        })
    )
});

export type ProductComparisonResult = z.TypeOf<typeof productComparisonResult>;

export const productComparisonTable = {
    verb: 'post',
    path: 'product-comparison/table',
    schema: {
        body: productComparisonRequest,
        response: {
            200: productComparisonResult
        }
    }
} as const satisfies EndpointContract;

export type ProductComparisonRequest = z.TypeOf<
    typeof productComparisonRequest
>;
